import './Pricing.css';

const plans = [
  {
    name: 'Starter',
    orbIcon: 'spark',
    price: '€339',
    period: 'Plan',
    cta: 'Choose this plan',
    features: [
      'Custom one-page design',
      'Mobile-first layout',
      'Basic SEO setup',
      'Contact form integration',
      'Email and call support'
    ]
  },
  {
    name: 'Business',
    orbIcon: 'rocket',
    price: '€499',
    period: 'Plan',
    cta: 'Choose this plan',
    features: [
      'Up to 6 custom pages',
      'CMS-ready architecture',
      'Performance optimization',
      'Analytics and tracking setup',
      'Priority chat support'
    ],
    featured: true
  },
  {
    name: 'Custom',
    orbIcon: 'shield',
    price: "Let's talk..",
    cta: 'Contact us',
    features: [
      'A plan based on your specific needs',
      'Brand identity support',
      'Conversion-focused copy support',
      'Custom API integrations',
    ]
  }
];

const orbIcons = {
  spark: (
    <svg viewBox="0 0 24 24" role="presentation" aria-hidden="true">
      <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3z" />
    </svg>
  ),
  rocket: (
    <svg viewBox="0 0 24 24" role="presentation" aria-hidden="true">
      <path d="M14.8 4.2c2.6-.3 4.5 1.6 4.2 4.2l-.5 3.8-7.5 7.5-1.9-1.9 1.5-2.7-1.2-1.2-2.7 1.5-1.9-1.9 7.5-7.5 2.5-.3zM7 18l-1.5 3.5L9 20l-2-2z" />
    </svg>
  ),
  shield: (
    <svg viewBox="0 0 24 24" role="presentation" aria-hidden="true">
      <path d="M12 3l7 3v5.5c0 4.5-2.9 7.6-7 9.5-4.1-1.9-7-5-7-9.5V6l7-3zm-1.1 12.8l5.2-5.2-1.4-1.4-3.8 3.8-1.9-1.9-1.4 1.4 3.3 3.3z" />
    </svg>
  )
};

function Pricing() {
  const handleScrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="pricing" id="services">
      <div className="pricing_inner">
        <p className="pricing_eyebrow">Pricing</p>
        <h2 className="contact_title">   Simple Packages for Modern Web Business </h2>
         <p className="section_subtitle">
          Clear scope, clean execution, and elegant design tailored to your stage of growth.
        </p>

        <div className="pricing_grid">
          {plans.map((plan) => (
            <article
              className={`pricing-card ${plan.featured ? 'is-featured' : ''}`}
              key={plan.name}
            >
              <div className="pricing-card_top">
                <span className="pricing-card_orb" aria-hidden="true">
                  <span className="pricing-card_orb-icon">{orbIcons[plan.orbIcon]}</span>
                </span>
                <h3>{plan.name}</h3>
                <p className="pricing-card_price-row">
                  <span className="pricing-card_price">{plan.price}</span>
                  {plan.period && <span className="pricing-card_period">{plan.period}</span>}
                </p>
                <button type="button" onClick={handleScrollToContact}>{plan.cta}</button>
              </div>

              <ul className="pricing-card_features">
                {plan.features.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Pricing;
